/* SOLENE theme.js â€” vanilla JS, no dependencies */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll lock manager (prevents conflict between mobile nav + cart drawer) ---------- */
  var ScrollLock = {
    _count: 0,
    _scrollY: 0,
    lock: function () {
      if (this._count === 0) {
        this._scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + this._scrollY + 'px';
        document.body.style.width = '100%';
      }
      this._count++;
    },
    unlock: function () {
      this._count = Math.max(0, this._count - 1);
      if (this._count === 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this._scrollY);
      }
    }
  };

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var threshold = 60;
    function update() {
      if (window.scrollY > threshold) header.classList.add('is-solid');
      else header.classList.remove('is-solid');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Mega menu (hover + keyboard) ---------- */
  function initMegaMenu() {
    var items = document.querySelectorAll('[data-nav-item]');
    items.forEach(function (item) {
      var link = item.querySelector('[data-nav-link]');
      var menu = item.querySelector('[data-mega-menu]');
      if (!menu) return;
      var closeTimer;
      function open() { clearTimeout(closeTimer); item.classList.add('is-open'); }
      function close() { closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 120); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      link.addEventListener('focus', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') item.classList.remove('is-open');
      });
    });
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    var closeBtn = document.querySelector('[data-mobile-nav-close]');
    if (!toggle || !nav) return;
    function open() {
      nav.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      ScrollLock.lock();
    }
    function close() {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      ScrollLock.unlock();
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Section reveal â€” fade in sections on scroll ---------- */
  function initSectionReveal() {
    if (reducedMotion) {
      document.querySelectorAll('[data-section-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var els = document.querySelectorAll('[data-section-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -80px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Scroll-linked image scale â€” images scale as they enter viewport ---------- */
  function initScrollScale() {
    if (reducedMotion) return;
    var els = document.querySelectorAll('[data-scroll-scale]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.top > vh || rect.bottom < 0) return;
        var progress = 1 - (rect.top / vh);
        progress = Math.max(0, Math.min(1, progress));
        var scale = 1.06 - (progress * 0.06);
        var img = el.querySelector('img');
        if (img) img.style.transform = 'scale(' + scale + ')';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Content parallax â€” elements shift vertically on scroll ---------- */
  function initScrollParallax() {
    if (reducedMotion) return;
    var els = document.querySelectorAll('[data-scroll-parallax]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top > vh || rect.bottom < 0) return;
        var center = rect.top + rect.height / 2;
        var offset = ((center / vh) - 0.5) * -40;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Hero parallax â€” scroll-linked translateY on hero media ---------- */
  function initHeroParallax() {
    var hero = document.querySelector('.hero');
    var media = hero ? hero.querySelector('.hero__media') : null;
    var scrollIndicator = hero ? hero.querySelector('.hero__scroll') : null;
    if (!hero || !media) return;

    /* Hide scroll indicator on scroll */
    if (scrollIndicator) {
      function updateIndicator() {
        if (window.scrollY > 80) scrollIndicator.style.opacity = '0';
        else scrollIndicator.style.opacity = '1';
      }
      updateIndicator();
      window.addEventListener('scroll', updateIndicator, { passive: true });
    }

    if (reducedMotion) return;
    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0) { ticking = false; return; }
      var progress = Math.min(1, Math.max(0, -rect.top / rect.height));
      media.style.transform = 'translateY(' + (progress * 80) + 'px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ---------- Cart drawer ---------- */
  var CartDrawer = {
    root: null,
    overlay: null,
    _prevFocus: null,
    _swipeStartX: 0,
    _swipeStartY: 0,
    init: function () {
      this.root = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      if (!this.root) return;
      var self = this;
      document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (btn.tagName === 'A') e.preventDefault();
          self.open();
        });
      });
      document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      /* Focus trap â€” keep tab inside the drawer when open */
      this.root.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        if (!self.root.classList.contains('is-open')) return;
        var focusable = self.root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      /* Swipe-to-close â€” touch gesture on the drawer */
      this.root.addEventListener('touchstart', function (e) {
        self._swipeStartX = e.changedTouches[0].clientX;
        self._swipeStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      this.root.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - self._swipeStartX;
        var dy = Math.abs(e.changedTouches[0].clientY - self._swipeStartY);
        if (dx > 80 && dy < 60) self.close();
      }, { passive: true });

      document.body.addEventListener('submit', function (e) {
        var form = e.target;
        if (form.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          self.addItem(form);
        }
      });

      this.root.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn) {
          e.preventDefault();
          self.updateItem(removeBtn.getAttribute('data-key'), 0);
        }
        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          var key = qtyBtn.getAttribute('data-key');
          var delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
          var input = self.root.querySelector('[data-qty-input="' + key + '"]');
          var newQty = Math.max(0, (parseInt(input.value, 10) || 1) + delta);
          /* Optimistic UI â€” update count immediately */
          if (input) input.value = newQty;
          if (newQty === 0) {
            var line = input ? input.closest('.cart-line') : null;
            if (line) line.style.display = 'none';
          }
          self.updateItem(key, newQty);
        }

        /* Direct qty input â€” user types a number */
        var qtyInput = e.target.closest('[data-qty-input]');
        if (qtyInput && (e.type === 'change' || (e.type === 'keydown' && e.key === 'Enter'))) {
          e.preventDefault();
          var k = qtyInput.getAttribute('data-qty-input');
          var val = Math.max(0, parseInt(qtyInput.value, 10) || 0);
          qtyInput.value = val;
          if (val === 0) {
            var lineEl = qtyInput.closest('.cart-line');
            if (lineEl) lineEl.style.display = 'none';
          }
          self.updateItem(k, val);
        }

        /* Cart note â€” save on change */
        var noteInput = e.target.closest('[data-cart-note]');
        if (noteInput && e.type === 'change') {
          fetch(window.Shopify ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: noteInput.value })
          });
        }
      });
    },
    open: function () {
      this._prevFocus = document.activeElement;
      this.root.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      ScrollLock.lock();
      /* "Added" feedback on add-to-cart buttons */
      var btns = document.querySelectorAll('[data-add-to-cart].is-loading');
      var self = this;
      btns.forEach(function (btn) {
        btn.classList.remove('is-loading');
        btn.textContent = 'Added';
        setTimeout(function () {
          var orig = btn.getAttribute('data-original-text');
          if (orig) btn.textContent = orig;
        }, 1800);
      });
      var closeBtn = this.root.querySelector('[data-cart-close]');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 100);
    },
    close: function () {
      this.root.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      ScrollLock.unlock();
      if (this._prevFocus) this._prevFocus.focus();
    },
    addItem: function (form) {
      var formData = new FormData(form);
      var self = this;
      var btn = form.querySelector('[data-add-to-cart]');
      fetch(window.Shopify ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (data) {
              var msg = (data && data.description) || 'Could not add item to cart.';
              self._resetBtn(btn);
              self._showError(msg);
              return Promise.reject(new Error(msg));
            });
          }
          return r.json();
        })
        .then(function () { return self.refresh(); })
        .then(function () { self.open(); })
        .catch(function (err) {
          console.error('Solene: add to cart failed', err);
          self._resetBtn(btn);
        });
    },
    _resetBtn: function (btn) {
      if (!btn) return;
      btn.classList.remove('is-loading');
      var orig = btn.getAttribute('data-original-text');
      if (orig) btn.textContent = orig;
    },
    _showError: function (msg) {
      var existing = document.querySelector('.cart-drawer__error');
      if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'cart-drawer__error';
      el.setAttribute('role', 'alert');
      el.textContent = msg;
      var header = this.root ? this.root.querySelector('.cart-drawer__header') : null;
      if (header && header.nextSibling) {
        header.parentNode.insertBefore(el, header.nextSibling);
      } else if (this.root) {
        this.root.prepend(el);
      }
      setTimeout(function () { el.remove(); }, 5000);
    },
    updateItem: function (key, quantity) {
      var self = this;
      fetch((window.Shopify ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { self.refresh(); })
        .catch(function (err) { console.error('Solene: cart update failed', err); });
    },
    refresh: function () {
      var self = this;
      return fetch((window.Shopify ? window.Shopify.routes.root : '/') + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          if (fresh) {
            var wasOpen = self.root.classList.contains('is-open');
            self.root.innerHTML = fresh.innerHTML;
            if (wasOpen) self.root.classList.add('is-open');
          }
          var freshCount = doc.querySelector('[data-cart-count]');
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            if (freshCount) el.textContent = freshCount.textContent;
          });
        });
    }
  };

  /* ---------- Saved objects — localStorage wishlist ---------- */
  var SavedPanel = {
    KEY: 'solene:saved:v1',
    MAX: 24,
    root: null,
    overlay: null,
    _prevFocus: null,
    escH: function (s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    read: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY)) || []; }
      catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(this.KEY, JSON.stringify(list.slice(0, this.MAX))); } catch (e) { /* storage unavailable */ }
    },
    has: function (url) {
      var list = this.read();
      for (var i = 0; i < list.length; i++) { if (list[i].url === url) return true; }
      return false;
    },
    toggle: function (data) {
      if (!data.url) return false;
      var list = this.read();
      var found = -1;
      for (var i = 0; i < list.length; i++) { if (list[i].url === data.url) { found = i; break; } }
      if (found > -1) list.splice(found, 1);
      else list.unshift(data);
      this.write(list);
      document.dispatchEvent(new CustomEvent('solene:saved-changed'));
      return found === -1;
    },
    removeItem: function (url) {
      this.write(this.read().filter(function (i) { return i.url !== url; }));
      document.dispatchEvent(new CustomEvent('solene:saved-changed'));
    },
    syncButtons: function () {
      var self = this;
      document.querySelectorAll('[data-save-toggle]').forEach(function (btn) {
        var on = self.has(btn.getAttribute('data-url'));
        btn.classList.toggle('is-saved', on);
        btn.setAttribute('aria-pressed', String(on));
        var label = btn.querySelector('[data-save-label]');
        if (label) label.textContent = on ? 'Saved' : 'Save';
      });
      var count = this.read().length;
      document.querySelectorAll('[data-saved-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },
    renderPanel: function () {
      if (!this.root) return;
      var list = this.read();
      var listEl = this.root.querySelector('[data-saved-list]');
      var emptyEl = this.root.querySelector('[data-saved-empty]');
      if (!listEl || !emptyEl) return;
      var self = this;
      var html = '';
      list.forEach(function (item) {
        var img = item.image ? '<img src="' + self.escH(item.image) + '" alt="" loading="lazy">' : '';
        html += '<li class="saved-line">'
          + '<a href="' + self.escH(item.url) + '" class="saved-line__link">'
          + '<span class="saved-line__img">' + img + '</span>'
          + '<span class="saved-line__body">'
          + '<span class="saved-line__title">' + self.escH(item.title) + '</span>'
          + '<span class="saved-line__price">' + self.escH(item.price) + '</span>'
          + '</span></a>'
          + '<button type="button" class="saved-line__remove" data-saved-remove="' + self.escH(item.url) + '" aria-label="Remove ' + self.escH(item.title) + '">&times;</button>'
          + '</li>';
      });
      listEl.innerHTML = html;
      emptyEl.hidden = list.length > 0;
      var countEl = this.root.querySelector('[data-saved-panel-count]');
      if (countEl) countEl.textContent = list.length;
    },
    open: function () {
      if (!this.root || !this.overlay) return;
      this.renderPanel();
      this._prevFocus = document.activeElement;
      this.root.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.root.setAttribute('aria-hidden', 'false');
      ScrollLock.lock();
      var closeBtn = this.root.querySelector('[data-saved-close]');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 100);
    },
    close: function () {
      if (!this.root || !this.overlay) return;
      this.root.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      ScrollLock.unlock();
      if (this._prevFocus) this._prevFocus.focus();
    },
    init: function () {
      var self = this;
      this.root = document.querySelector('[data-saved-panel]');
      this.overlay = document.querySelector('[data-saved-overlay]');

      /* Delegated clicks — works for cards rendered via AJAX too */
      document.addEventListener('click', function (e) {
        var toggleBtn = e.target.closest('[data-save-toggle]');
        if (toggleBtn) {
          e.preventDefault();
          self.toggle({
            url: toggleBtn.getAttribute('data-url'),
            title: toggleBtn.getAttribute('data-title'),
            price: toggleBtn.getAttribute('data-price') || '',
            image: toggleBtn.getAttribute('data-image') || ''
          });
          return;
        }
        var openBtn = e.target.closest('[data-saved-open]');
        if (openBtn && self.root) { e.preventDefault(); self.open(); return; }
        var removeBtn = e.target.closest('[data-saved-remove]');
        if (removeBtn) {
          e.preventDefault();
          self.removeItem(removeBtn.getAttribute('data-saved-remove'));
        }
      });

      if (!this.root) { this.syncButtons(); return; }

      var closeBtn = this.root.querySelector('[data-saved-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
      this.overlay.addEventListener('click', function () { self.close(); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.close();
      });

      /* Focus trap */
      this.root.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !self.root.classList.contains('is-open')) return;
        var focusable = self.root.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      /* Close the panel when a saved object is opened */
      this.root.addEventListener('click', function (e) {
        if (e.target.closest('.saved-line__link')) self.close();
      });

      document.addEventListener('solene:saved-changed', function () {
        self.syncButtons();
        self.renderPanel();
      });

      this.syncButtons();
    }
  };

  /* ---------- Newsletter loading state ---------- */
  function initNewsletterLoading() {
    var forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        form.classList.add('is-loading');
        var btnText = form.querySelector('[data-newsletter-btn-text]');
        if (btnText) {
          btnText.setAttribute('data-original-text', btnText.textContent);
          btnText.textContent = 'Sending\u2026';
        }
      });
    });
  }

  /* ---------- Product image zoom ---------- */
  function initProductZoom() {
    var overlays = document.querySelectorAll('[data-zoom-overlay]');
    overlays.forEach(function (overlay) {
      var zoomImg = overlay.querySelector('[data-zoom-img]');
      var closeBtn = overlay.querySelector('[data-zoom-close]');
      var galleryWrap = overlay.closest('[data-product-gallery]');
      if (!galleryWrap || !zoomImg) return;

      var openBtn = galleryWrap.querySelector('[data-zoom-btn]');
      var mainImg = galleryWrap.querySelector('[data-gallery-main]');
      var prevFocus = null;

      function open() {
        if (!mainImg || !mainImg.src) return;
        prevFocus = document.activeElement;
        var img = document.createElement('img');
        img.src = mainImg.src;
        img.alt = mainImg.alt;
        zoomImg.innerHTML = '';
        zoomImg.appendChild(img);
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        ScrollLock.lock();
        if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 100);
      }
      function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        ScrollLock.unlock();
        zoomImg.innerHTML = '';
        if (prevFocus) prevFocus.focus();
      }
      if (openBtn) openBtn.addEventListener('click', open);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
    });
  }

  /* ---------- Size guide modal ---------- */
  function initSizeGuide() {
    var modal = document.querySelector('[data-sizeguide]');
    if (!modal) return;
    var overlay = document.querySelector('[data-sizeguide-overlay]');
    var prevFocus = null;
    function open() {
      prevFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      ScrollLock.lock();
      var btn = modal.querySelector('[data-sizeguide-close]');
      if (btn) setTimeout(function () { btn.focus(); }, 100);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      ScrollLock.unlock();
      if (prevFocus) prevFocus.focus();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sizeguide-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-sizeguide-close]')) { e.preventDefault(); close(); return; }
      if (overlay && e.target === overlay && modal.classList.contains('is-open')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ---------- Add-to-cart loading state ---------- */
  function initCartLoading() {
    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn && !btn.disabled) {
        btn.classList.add('is-loading');
        btn.setAttribute('data-original-text', btn.textContent);
      }
    });
  }

  /* ---------- Back to top ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    var ticking = false;
    function update() {
      if (window.scrollY > 600) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Sticky mobile ATC bar ---------- */
  function initStickyATC() {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainBtn = document.querySelector('[data-add-to-cart]');
    if (!bar || !mainBtn) return;
    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
    var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    /* Mirror main button text to sticky bar */
    function syncStickyBtn() {
      if (stickyBtn) {
        stickyBtn.textContent = mainBtn.textContent;
        stickyBtn.disabled = mainBtn.disabled;
      }
      if (stickyPrice) {
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl) stickyPrice.textContent = priceEl.textContent;
      }
    }
    /* Show/hide bar based on main button visibility */
    var ticking = false;
    var floatCart = document.querySelector('.mobile-float-cart');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
          if (floatCart) floatCart.classList.add('sticky-atc-active');
          syncStickyBtn();
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
          if (floatCart) floatCart.classList.remove('sticky-atc-active');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainBtn);
    /* Sticky bar click triggers main button */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!mainBtn.disabled) mainBtn.click();
      });
    }
  }

  /* ---------- Accordion ---------- */
  function initAccordion() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        var panel = item.querySelector('[data-accordion-panel]');
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.setAttribute('aria-hidden', String(isOpen));
        if (isOpen) {
          panel.style.maxHeight = '0px';
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---------- Product gallery + variant selection ---------- */
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(function (formWrap) {
      var mainImg = formWrap.querySelector('[data-gallery-main]');
      formWrap.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          formWrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            var newSrc = thumb.getAttribute('data-full-src');
            if (newSrc && newSrc !== mainImg.src) {
              mainImg.classList.add('is-switching');
              setTimeout(function () {
                mainImg.src = newSrc;
                mainImg.onload = function () {
                  mainImg.classList.remove('is-switching');
                };
              }, 200);
            }
          }
        });
      });

      var qtyInput = formWrap.querySelector('[data-qty-field]');
      formWrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
          qtyInput.value = val;
        });
      });

      var variantData = formWrap.getAttribute('data-variants');
      var variants = [];
      try { variants = JSON.parse(variantData || '[]'); } catch (e) { variants = []; }
      var selected = {};
      var idField = formWrap.querySelector('[data-variant-id-field]');
      var priceEl = formWrap.querySelector('[data-product-price]');
      var addBtn = formWrap.querySelector('[data-add-to-cart]');
      var availabilityEl = formWrap.querySelector('[data-availability]');
      var stockEl = formWrap.querySelector('[data-stock-note]');

      function findVariant() {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return selected[i] === opt; });
        });
      }
      function isSellable(v) { return !!v && (v.available || v.inventory_policy === 'continue'); }

      function updateSwatchStates() {
        formWrap.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          group.querySelectorAll('.variant-swatch').forEach(function (swatch) {
            var prev = selected[idx];
            selected[idx] = swatch.getAttribute('data-value');
            var match = null;
            for (var i = 0; i < variants.length; i++) {
              var v = variants[i];
              var ok = v.options.every(function (opt, j) { return j === idx || selected[j] === opt; });
              if (ok) { match = v; break; }
            }
            var usable = isSellable(match);
            swatch.classList.toggle('is-disabled', !usable);
            swatch.setAttribute('aria-disabled', usable ? 'false' : 'true');
            selected[idx] = prev;
          });
        });
      }
      function syncUI() {
        updateSwatchStates();
        formWrap.querySelectorAll('[data-option-value]').forEach(function (el) {
          el.textContent = selected[el.getAttribute('data-option-value')] || '';
        });
        var variant = findVariant();
        if (!variant) return;
        if (idField) idField.value = variant.id;
        var buyNowField = document.querySelector('[data-buynow-variant-id]');
        if (buyNowField) buyNowField.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (addBtn) {
          var isAvailable = variant.available || variant.inventory_policy === 'continue';
          addBtn.disabled = !isAvailable;
          addBtn.textContent = isAvailable ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
        }
        if (availabilityEl) availabilityEl.textContent = (variant.available || variant.inventory_policy === 'continue') ? availabilityEl.getAttribute('data-in-stock') : availabilityEl.getAttribute('data-out-stock');
        if (stockEl) {
          var qty = parseInt(variant.inventory_quantity, 10);
          var showLow = isSellable(variant) && variant.inventory_policy !== 'continue' && !isNaN(qty) && qty > 0 && qty <= 5;
          stockEl.textContent = showLow ? 'Only ' + qty + ' remaining' : '';
          if (showLow) { stockEl.removeAttribute('hidden'); } else { stockEl.setAttribute('hidden', ''); }
        }
      }

      formWrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var activeBtn = group.querySelector('.variant-swatch.is-selected');
        if (activeBtn) selected[index] = activeBtn.getAttribute('data-value');
        group.querySelectorAll('.variant-swatch').forEach(function (swatch) {
          swatch.addEventListener('click', function () {
            group.querySelectorAll('.variant-swatch').forEach(function (s) {
              s.classList.remove('is-selected');
              s.setAttribute('aria-checked', 'false');
            });
            swatch.classList.add('is-selected');
            swatch.setAttribute('aria-checked', 'true');
            selected[index] = swatch.getAttribute('data-value');
            syncUI();
          });
        });
      });
      syncUI();
    });
  }

  /* ---------- Floating mobile cart ---------- */
  function initFloatingCart() {
    var btn = document.querySelector('.mobile-float-cart');
    if (!btn) return;
    var hero = document.querySelector('[data-hero]');
    var ticking = false;
    function update() {
      var scrollY = window.scrollY;
      var docHeight = document.documentElement.scrollHeight;
      var winHeight = window.innerHeight;
      var heroBottom = hero ? hero.getBoundingClientRect().bottom + scrollY : window.innerHeight * 0.8;
      var pastHero = scrollY > heroBottom - 100;
      var nearFooter = scrollY + winHeight > docHeight - 200;
      if (pastHero && !nearFooter) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Newsletter (Shopify customer form handles submission natively) ---------- */

  /* ---------- Predictive search â€” shared module ---------- */
  function createPredictiveSearch(root) {
    var input = root.querySelector('[data-search-input]');
    var dropdown = root.querySelector('[data-search-dropdown]');
    var resultsContainer = root.querySelector('[data-search-results]');
    if (!input || !dropdown || !resultsContainer) return null;

    var debounceTimer = null;
    var activeIndex = -1;
    var isOpen = false;
    var lastQuery = '';

    function escH(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function escR(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function hlMatch(t, q) { if (!q) return escH(t); var e = escH(t); return e.replace(new RegExp('(' + escR(q) + ')', 'gi'), '<strong>$1</strong>'); }

    function openDd() { if (isOpen) return; isOpen = true; dropdown.classList.add('is-open'); dropdown.setAttribute('aria-hidden', 'false'); }
    function closeDd() { isOpen = false; dropdown.classList.remove('is-open'); dropdown.setAttribute('aria-hidden', 'true'); activeIndex = -1; }

    function renderResults(results, query) {
      var html = '';
      var groups = [{ key: 'products', label: 'Objects' }, { key: 'articles', label: 'Journal' }, { key: 'pages', label: 'Pages' }];
      var total = 0;
      groups.forEach(function (g) { if (results[g.key]) total += results[g.key].length; });
      if (total === 0) { resultsContainer.innerHTML = '<div class="predictive-search__empty">No results for "' + escH(query) + '"</div>'; return; }
      groups.forEach(function (g) {
        var items = results[g.key];
        if (!items || !items.length) return;
        html += '<div class="predictive-search__group-label">' + g.label + '</div>';
        items.forEach(function (item) {
          var img = item.image ? '<img class="predictive-search__result-img" src="' + escH(item.image) + '" alt="" loading="lazy">' : '<div class="predictive-search__result-img--placeholder">' + g.label.charAt(0) + '</div>';
          var price = item.price ? '<span class="predictive-search__result-price">' + escH(item.price) + '</span>' : '';
          html += '<a href="' + escH(item.url) + '" class="predictive-search__result">' + img + '<div class="predictive-search__result-body"><span class="predictive-search__result-title">' + hlMatch(item.title, query) + '</span><span class="predictive-search__result-meta">' + g.label + '</span></div>' + price + '</a>';
        });
      });
      resultsContainer.innerHTML = html;
      activeIndex = -1;
    }

    function fetchSuggestions(query) {
      if (query.length < 2) { closeDd(); return; }
      if (query === lastQuery) return;
      lastQuery = query;
      resultsContainer.innerHTML = '<div class="predictive-search__loading">Searching\u2026</div>';
      openDd();
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value !== query) return; renderResults(data.resources.results, query); })
        .catch(function () { resultsContainer.innerHTML = '<div class="predictive-search__empty">Something went wrong.</div>'; });
    }

    function navR(dir) {
      var items = resultsContainer.querySelectorAll('.predictive-search__result');
      if (!items.length) return;
      items.forEach(function (el) { el.classList.remove('is-active'); });
      activeIndex = Math.max(-1, Math.min(items.length - 1, activeIndex + dir));
      if (activeIndex >= 0) { items[activeIndex].classList.add('is-active'); items[activeIndex].scrollIntoView({ block: 'nearest' }); }
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      debounceTimer = setTimeout(function () { fetchSuggestions(query); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); navR(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); navR(-1); }
      else if (e.key === 'Enter') {
        var items = resultsContainer.querySelectorAll('.predictive-search__result');
        if (activeIndex >= 0 && items[activeIndex]) { e.preventDefault(); window.location.href = items[activeIndex].getAttribute('href'); }
      }
      else if (e.key === 'Escape') { closeDd(); }
    });

    return { input: input, closeDd: closeDd, fetchSuggestions: fetchSuggestions };
  }

  /* ---------- Predictive search â€” search page ---------- */
  function initPredictiveSearch() {
    var root = document.querySelector('.wrap [data-predictive-search]');
    if (!root) return;
    var ps = createPredictiveSearch(root);
    if (!ps) return;
    ps.input.addEventListener('focus', function () {
      if (ps.input.value.trim().length >= 2) { ps.fetchSuggestions(ps.input.value.trim()); }
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) ps.closeDd(); });
    document.addEventListener('focusin', function (e) { if (!root.contains(e.target)) ps.closeDd(); });
  }

  /* ---------- Collection AJAX filtering ---------- */
  function fetchCollectionSection(url) {
    var grid = document.querySelector('[data-collection-grid]');
    var loading = document.querySelector('[data-collection-loading]');
    if (!grid) return;
    if (loading) loading.classList.add('is-active');
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';

    var separator = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + separator + 'section_id=main';

    fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#CollectionProductGrid');
        if (!newGrid) return;

        /* Preserve the wrapper, replace inner content */
        grid.innerHTML = newGrid.innerHTML;
        grid.style.opacity = '';
        grid.style.pointerEvents = '';
        if (loading) loading.classList.remove('is-active');

        /* Update product count after AJAX swap */
        var freshCount = doc.querySelector('[data-collection-count]');
        var countEl = document.querySelector('[data-collection-count]');
        if (freshCount && countEl) countEl.textContent = freshCount.textContent;

        /* Push URL to history without reload */
        history.pushState({}, '', url);

        /* Re-init scroll reveal on new items */
        initReveal();
        initSectionReveal();
        initScrollScale();
        initScrollParallax();
      })
      .catch(function () {
        /* Fallback: full page reload on network error */
        window.location.href = url;
      });
  }

  function initCollectionFilters() {
    var container = document.querySelector('[data-collection-filters]');
    if (!container) return;

    /* Filter button clicks */
    var btns = document.querySelectorAll('[data-filter-btn]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('data-url');
        if (!url) return;

        /* Update active state immediately */
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        /* Remove the "clear" button if present, or add it if filtering */
        var clearBtn = document.querySelector('.collection-active-filter');
        if (clearBtn) clearBtn.remove();
        if (btn.getAttribute('data-url') !== container.querySelector('[data-filter-btn]').getAttribute('data-url')) {
          var tag = btn.textContent.trim();
          if (tag !== 'All') {
            var clear = document.createElement('a');
            clear.className = 'collection-active-filter';
            clear.setAttribute('data-filter-btn', '');
            clear.setAttribute('data-url', container.querySelector('[data-filter-btn]').getAttribute('data-url'));
            clear.innerHTML = tag + ' <span class="collection-active-filter__x">&times;</span>';
            container.parentElement.insertBefore(clear, container);
            clear.addEventListener('click', function (ev) {
              ev.preventDefault();
              fetchCollectionSection(clear.getAttribute('data-url'));
              initCollectionFilters();
            });
          }
        }

        fetchCollectionSection(url);
      });
    });

    /* Clear filter link (rendered by Liquid when active_tag is set) */
    var clearFilter = document.querySelector('.collection-active-filter[data-filter-btn]');
    if (clearFilter) {
      clearFilter.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCollectionSection(clearFilter.getAttribute('data-url'));
        initCollectionFilters();
      });
    }
  }

  /* ---------- Collection AJAX sort ---------- */
  function initCollectionSort() {
    var sort = document.querySelector('[data-collection-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      fetchCollectionSection(sort.value);
    });
  }

  /* ---------- Collection AJAX pagination ---------- */
  function initCollectionPagination() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-pagination-link]');
      if (!link) return;
      e.preventDefault();
      var url = link.getAttribute('href');
      if (url) {
        fetchCollectionSection(url);
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    });
  }

  /* ---------- Header search overlay ---------- */
  function initHeaderSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var overlay = document.querySelector('[data-search-overlay]');
    var closeBtn = document.querySelector('[data-search-close]');
    var input = overlay ? overlay.querySelector('[data-search-input]') : null;
    var root = overlay ? overlay.querySelector('[data-predictive-search]') : null;
    if (!toggle || !overlay) return;

    var ps = root ? createPredictiveSearch(root) : null;

    function open() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      ScrollLock.lock();
      toggle.setAttribute('aria-expanded', 'true');
      if (input) setTimeout(function () { input.focus(); }, 100);
    }
    function close() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      ScrollLock.unlock();
      toggle.setAttribute('aria-expanded', 'false');
      if (input) { input.value = ''; input.blur(); }
      if (ps) ps.closeDd();
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* Override Escape in the shared module to also close the overlay */
    if (ps && ps.input) {
      ps.input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
          e.stopPropagation();
          close();
        }
      });
    }
  }

  /* ---------- Page transitions ---------- */
  function initPageTransitions() {
    if (reducedMotion) return;
    /* Native View Transitions handle the crossfade where supported — JS overlay is fallback only */
    if ('startViewTransition' in document) return;
    var overlay = document.querySelector('[data-page-transition]');
    if (!overlay) return;
    var transitioning = false;
    document.addEventListener('click', function (e) {
      if (transitioning) return;
      var link = e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (link.target === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (link.closest('[data-cart-drawer]')) return;
      if (link.closest('.cart-line')) return;
      if (link.closest('[data-saved-panel]')) return;
      if (href.indexOf('/checkout') !== -1) return;
      if (href.indexOf('/cart') !== -1) return;
      if (href.indexOf('/account') !== -1) return;
      if (link.hasAttribute('data-no-transition')) return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname) return;
      e.preventDefault();
      transitioning = true;
      overlay.classList.add('is-active');
      setTimeout(function () { window.location.href = href; }, 150);
    });
  }


  function initSpinViewer() {
    var viewers = document.querySelectorAll('[data-spin-viewer]');
    if (!viewers.length) return;
    viewers.forEach(function (viewer) {
      var urls = [];
      try { urls = JSON.parse(viewer.getAttribute('data-spin-urls') || '[]'); } catch (err) { urls = []; }
      urls = urls.filter(Boolean);
      var imgEl = viewer.querySelector('[data-spin-img]');
      var countEl = viewer.querySelector('[data-spin-count]');
      if (!imgEl || urls.length < 2) return;
      var idx = 0;
      var dragging = false;
      var startX = 0;
      var startIdx = 0;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function show(i) {
        idx = ((i % urls.length) + urls.length) % urls.length;
        imgEl.src = urls[idx];
        if (countEl) countEl.textContent = pad(idx + 1) + ' / ' + pad(urls.length);
      }
      function preload() {
        urls.forEach(function (u) { var im = new Image(); im.src = u; });
      }
      if ('requestIdleCallback' in window) { requestIdleCallback(preload); } else { setTimeout(preload, 1600); }
      viewer.addEventListener('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startIdx = idx;
        viewer.classList.add('is-dragging');
        if (viewer.setPointerCapture) {
          try { viewer.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });
      viewer.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var step = Math.round((e.clientX - startX) / 18);
        if (step !== 0) show(startIdx + step);
      });
      function endDrag() {
        dragging = false;
        viewer.classList.remove('is-dragging');
      }
      viewer.addEventListener('pointerup', endDrag);
      viewer.addEventListener('pointercancel', endDrag);
      viewer.addEventListener('pointerleave', endDrag);
      viewer.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      });
      show(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMegaMenu();
    initMobileNav();
    initReveal();
    initSectionReveal();
    initScrollScale();
    initScrollParallax();
    initHeroParallax();
    CartDrawer.init();
    initAccordion();
    initProductForm();
    initNewsletterLoading();
    initProductZoom();
    initCartLoading();
    initBackToTop();
    initFloatingCart();
    initCollectionSort();
    initCollectionFilters();
    initCollectionPagination();
    initPredictiveSearch();
    initHeaderSearch();
    initStickyATC();
    SavedPanel.init();
    initSizeGuide();
    initSpinViewer();
    initPageTransitions();
  });
})();
